module.exports = __webpack_public_path__ + "assets/img/experience-3.7582dd3b.svg";